import React from 'react';
import aboutCardImage from '../../../assets/images/home/aboutCardImage/aboutCardImage.png';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { useNavigate } from 'react-router-dom';

const AboutUsCard = () => {
    const navigate = useNavigate();

    return (
        <div className="home-about-us-card">
            <div className="home-about-us-contents">
                <div className="home-about-us-description">
                    <h1>WHO WE ARE</h1>
                    <p>
                        With years of expertise in residential, commercial, and industrial construction,
                        we are committed to delivering high-quality projects that stand the test of time.
                        From planning to execution, our skilled team ensures precision, safety, and efficiency in every build.
                    </p>
                    <button
                        className="home-about-us-learn-more-button"
                        onClick={() => {
                            navigate('/About');
                            window.scrollTo({ top: 0 });
                        }}
                        aria-label="Learn more about us"
                    >
                        Learn More
                    </button>
                </div>
                <div className="home-about-us-image-container">
                    <LazyLoadImage
                        draggable={false}
                        src={aboutCardImage}
                        alt="Construction site"
                        effect="blur"
                        width="100%"
                        height="100%"
                        style={{ objectFit: 'cover' }}
                    />
                </div>
            </div>
        </div>
    );
};

export default AboutUsCard;